<div *ngIf="data && data.styles" class="flex" [ngClass]="{'justify-start': data.styles.alignButtons === 'left', 'justify-center': data.styles.alignButtons === 'center', 'justify-end': data.styles.alignButtons === 'right' || !data.styles.alignButtons}">
<div 
  [style.color]="textColor" 
  [innerHTML]="customText | safeHtml"
  (click)="goToCancelRequest()"
  *ngIf="!loading"
  class="subheading-1 px-2 text-right underline cursor-pointer custom-html">
</div>

<div 
  *ngIf="loading"
  class="subheading-1 px-2 text-right text-orange-500 custom-html">
  {{labels.loadings.cancelingRequest}}
</div>
</div>

